import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import CategoryCard from 'modules/events/categories/CategoryCard';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import Button from 'components/_UI/Button';
import Text from 'components/_UI/Text';
import establishmentsApi from 'api/requests/establishments';
import CategoryCardSkeleton from 'components/commons/skeletons/CategoryCardSkeleton';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';

const VISIBLE_COUNT = 10;

export default function EstablishmentCategoriesList() {
    const [tags, setTags] = useState(null);
    const [showAll, setShowAll] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchTags() {
            try {
                const { data } = await establishmentsApi.getTags();
                setTags(data?.data || []);
            } catch (error) {
                console.error('Error fetching establishment tags:', error);
            }
        }
        fetchTags();
    }, []);

    function handleCategoryClick(tagName) {
        navigate(`${paths.establishments.search}?tags=${encodeURIComponent(tagName)}`);
    }

    const visibleTags = tags === null ? [] : showAll ? tags : tags.slice(0, VISIBLE_COUNT);

    return (
        <Container>
            {tags === null ? (
                [1,2,3,4,5,6].map(i => <CategoryCardSkeleton key={i} />)
            ) : visibleTags.map(tag => (
                <CategoryCard
                    data={tag}
                    key={tag.id}
                    onClick={() => handleCategoryClick(tag.name)}
                />
            ))}

            {tags?.length > VISIBLE_COUNT && (
                <ButtonRow>
                    <Column width='auto'>
                        <Button category='minimal' onClick={() => setShowAll(prev => !prev)}>
                            <Text
                                paddingBottom={0}
                                type='bold'
                                name='normal'
                                color={colors.occasionalPurple}
                            >
                                {showAll ? 'Ver menos' : 'Ver todas categorias'}
                            </Text>
                        </Button>
                    </Column>
                </ButtonRow>
            )}
        </Container>
    )
}

const ButtonRow = styled(FullyCentered)`
    width: 100% !important;
    aspect-ratio: unset !important;
    height: auto !important;
    margin-top: 15px !important;
    margin-right: 0 !important;
`;

const Container = styled(Row)`
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;

    & > div {
        margin: 0;
        flex-shrink: 0;
    }
`;
